module.exports = __webpack_public_path__ + "img/team2.091cb6a5.webp";